import iconfaqs from './iconfaqs';

export default iconfaqs;



// WEBPACK FOOTER //
// ./src/pages/static/iconfaqs/index.jsx